'use client';
import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { useSearch } from './useSearch';
import { SearchResults } from './SearchResults';
import { clarityEvent } from '@/lib/clarity';
import './search.scss';

export const InlineSearch = () => {
    const router = useRouter();
    const [query, setQuery] = useState('');
    const { data, loading } = useSearch(query);
    const showResults = query.trim().length >= 2;

    const runSearch = (text) => {
        clarityEvent('Search');
        router.push(`/search?q=${encodeURIComponent(text)}`);
        setQuery('');
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const q = query.trim();
        if (q) runSearch(q);
    };

    return (
        <div className="inline-search-root">
            <form onSubmit={handleSubmit} className="inline-search-form" role="search" noValidate style={{ width: '100%' }}>
                <IconField iconPosition="left" style={{ width: '100%', display: 'block' }}>
                    <InputIcon className="pi pi-search search-icon" />
                    <InputText
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        onKeyDown={(e) => { if (e.key === 'Escape') setQuery(''); }}
                        placeholder="Search products, e.g. Smart Switch"
                        className="inline-search-input"
                        style={{ width: '100%', boxSizing: 'border-box', height: 'auto', minHeight: 44, maxHeight: 60 }}
                        aria-label="Search products"
                        autoComplete="off"
                    />
                </IconField>
            </form>

            {showResults && (
                <SearchResults
                    data={data}
                    loading={loading}
                    query={query}
                    onSuggestionClick={runSearch}
                    onClose={() => setQuery('')}
                    inline
                />
            )}
        </div>
    );
};
